import { render } from "./IgnoreRecord.vue?vue&type=template&id=d0f669a0&scoped=true"
import script from "./IgnoreRecord.vue?vue&type=script&lang=js"
export * from "./IgnoreRecord.vue?vue&type=script&lang=js"

import "./IgnoreRecord.vue?vue&type=style&index=0&id=d0f669a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0f669a0"]])

export default __exports__